import { Box, Divider } from '@material-ui/core'
import React from 'react'
import { formatCentsToPrettyDollars } from '../teams/perks/giftCardUtils'

const ReserveRestaurantPaymentDetails = ({ orderFeeInCents, deliveryFeeInCents }) => {
  return (
    <Box
      className="-rightSide"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="flex-end"
    >
      <Box textAlign="right">
        <p>
          <b>{formatCentsToPrettyDollars(orderFeeInCents)}</b>
        </p>
        <p>Order Fee</p>
        <Box marginY={2}>
          <Divider />
        </Box>
      </Box>
      <Box textAlign="right">
        <p>
          <b>{formatCentsToPrettyDollars(deliveryFeeInCents)}</b>
        </p>
        <p>Reserve Fee</p>
      </Box>
    </Box>
  )
}

export default ReserveRestaurantPaymentDetails
